const VERSION = '3.1.1';
export function getVersionString() {
    return VERSION;
}
